import { Link } from "react-router-dom";

import { TesseractSpin } from "./TesseractSpin";

export function SiteFooter() {
  return (
    <footer className="hub-footer">
      <Link className="footer-quest" to="/" aria-label="SideQuest HQ home">
        <TesseractSpin size={40} />
        <span>SideQuest <strong>HQ</strong></span>
      </Link>
      <a className="footer-brand" href="https://cc-lab.xyz" target="_blank" rel="noopener noreferrer">
        <img className="footer-lab-logo" src="https://cc-lab.xyz/cc-lab-logo-transparent-bg-160.webp" alt="" width={160} height={160} decoding="async" />
        <span>Built by <strong>CC-Lab</strong></span>
      </a>
    </footer>
  );
}
